module.exports = __webpack_public_path__ + "img/cars.7e129e3a.png";